module.exports = __webpack_public_path__ + "img/pressingKnife2.a3c96f38.png";